function sandbox(inNewContext) {
    var lodashModule = {}, original_;
    try {
        lodashModule = require.cache[require.resolve("lodash")];
    } catch (e) {
        if (typeof(window) == "undefined")
            window = {};
        if (!window._)
            window._ = require("lodash");
        inNewContext = window._;
    }
    original_ = lodashModule.exports;
    lodashModule.exports = inNewContext;
    require("./_.collections.walk.js");
    require("./_.function.arity.js");
    require("./_.function.combinators.js");
    require("./_.function.dispatch.js");
    require("./_.function.iterators.js");
    require("./_.function.predicates.js");
    require("./_.object.builders.js");
    require("./_.object.selectors.js");
    require("./_.util.operators.js");
    require("./_.util.strings.js");
    require("./_.util.trampolines.js");
    lodashModule.exports = original_;
    return inNewContext;
}
var inNewContext = sandbox(require("lodash").runInContext());

require("./common-js/_.array.builders.js")(inNewContext);
require("./common-js/_.array.selectors.js")(inNewContext);
require("./common-js/_.util.existential.js")(inNewContext);


module.exports                     = inNewContext;
module.exports.support             = inNewContext.support;
module.exports.templateSettings    = inNewContext.templateSettings;
module.exports.after               = inNewContext.after;
module.exports.assign              = inNewContext.assign;
module.exports.at                  = inNewContext.at;
module.exports.bind                = inNewContext.bind;
module.exports.bindAll             = inNewContext.bindAll;
module.exports.bindKey             = inNewContext.bindKey;
module.exports.chain               = inNewContext.chain;
module.exports.compact             = inNewContext.compact;
module.exports.compose             = inNewContext.compose;
module.exports.constant            = inNewContext.constant;
module.exports.countBy             = inNewContext.countBy;
module.exports.create              = inNewContext.create;
module.exports.createCallback      = inNewContext.createCallback;
module.exports.curry               = inNewContext.curry;
module.exports.debounce            = inNewContext.debounce;
module.exports.defaults            = inNewContext.defaults;
module.exports.defer               = inNewContext.defer;
module.exports.delay               = inNewContext.delay;
module.exports.difference          = inNewContext.difference;
module.exports.filter              = inNewContext.filter;
module.exports.flatten             = inNewContext.flatten;
module.exports.forEach             = inNewContext.forEach;
module.exports.forEachRight        = inNewContext.forEachRight;
module.exports.forIn               = inNewContext.forIn;
module.exports.forInRight          = inNewContext.forInRight;
module.exports.forOwn              = inNewContext.forOwn;
module.exports.forOwnRight         = inNewContext.forOwnRight;
module.exports.functions           = inNewContext.functions;
module.exports.groupBy             = inNewContext.groupBy;
module.exports.indexBy             = inNewContext.indexBy;
module.exports.initial             = inNewContext.initial;
module.exports.intersection        = inNewContext.intersection;
module.exports.invert              = inNewContext.invert;
module.exports.invoke              = inNewContext.invoke;
module.exports.keys                = inNewContext.keys;
module.exports.map                 = inNewContext.map;
module.exports.mapValues           = inNewContext.mapValues;
module.exports.max                 = inNewContext.max;
module.exports.memoize             = inNewContext.memoize;
module.exports.merge               = inNewContext.merge;
module.exports.min                 = inNewContext.min;
module.exports.omit                = inNewContext.omit;
module.exports.once                = inNewContext.once;
module.exports.pairs               = inNewContext.pairs;
module.exports.partial             = inNewContext.partial;
module.exports.partialRight        = inNewContext.partialRight;
module.exports.pick                = inNewContext.pick;
module.exports.pluck               = inNewContext.pluck;
module.exports.property            = inNewContext.property;
module.exports.pull                = inNewContext.pull;
module.exports.range               = inNewContext.range;
module.exports.reject              = inNewContext.reject;
module.exports.remove              = inNewContext.remove;
module.exports.rest                = inNewContext.rest;
module.exports.shuffle             = inNewContext.shuffle;
module.exports.sortBy              = inNewContext.sortBy;
module.exports.tap                 = inNewContext.tap;
module.exports.throttle            = inNewContext.throttle;
module.exports.times               = inNewContext.times;
module.exports.toArray             = inNewContext.toArray;
module.exports.transform           = inNewContext.transform;
module.exports.union               = inNewContext.union;
module.exports.uniq                = inNewContext.uniq;
module.exports.values              = inNewContext.values;
module.exports.where               = inNewContext.where;
module.exports.without             = inNewContext.without;
module.exports.wrap                = inNewContext.wrap;
module.exports.xor                 = inNewContext.xor;
module.exports.zip                 = inNewContext.zip;
module.exports.zipObject           = inNewContext.zipObject;
module.exports.collect             = inNewContext.collect;
module.exports.drop                = inNewContext.drop;
module.exports.each                = inNewContext.each;
module.exports.eachRight           = inNewContext.eachRight;
module.exports.extend              = inNewContext.extend;
module.exports.methods             = inNewContext.methods;
module.exports.object              = inNewContext.object;
module.exports.select              = inNewContext.select;
module.exports.tail                = inNewContext.tail;
module.exports.unique              = inNewContext.unique;
module.exports.unzip               = inNewContext.unzip;
module.exports.clone               = inNewContext.clone;
module.exports.cloneDeep           = inNewContext.cloneDeep;
module.exports.contains            = inNewContext.contains;
module.exports.escape              = inNewContext.escape;
module.exports.every               = inNewContext.every;
module.exports.find                = inNewContext.find;
module.exports.findIndex           = inNewContext.findIndex;
module.exports.findKey             = inNewContext.findKey;
module.exports.findLast            = inNewContext.findLast;
module.exports.findLastIndex       = inNewContext.findLastIndex;
module.exports.findLastKey         = inNewContext.findLastKey;
module.exports.has                 = inNewContext.has;
module.exports.identity            = inNewContext.identity;
module.exports.indexOf             = inNewContext.indexOf;
module.exports.isArguments         = inNewContext.isArguments;
module.exports.isArray             = inNewContext.isArray;
module.exports.isBoolean           = inNewContext.isBoolean;
module.exports.isDate              = inNewContext.isDate;
module.exports.isElement           = inNewContext.isElement;
module.exports.isEmpty             = inNewContext.isEmpty;
module.exports.isEqual             = inNewContext.isEqual;
module.exports.isFinite            = inNewContext.isFinite;
module.exports.isFunction          = inNewContext.isFunction;
module.exports.isNaN               = inNewContext.isNaN;
module.exports.isNull              = inNewContext.isNull;
module.exports.isNumber            = inNewContext.isNumber;
module.exports.isObject            = inNewContext.isObject;
module.exports.isPlainObject       = inNewContext.isPlainObject;
module.exports.isRegExp            = inNewContext.isRegExp;
module.exports.isString            = inNewContext.isString;
module.exports.isUndefined         = inNewContext.isUndefined;
module.exports.lastIndexOf         = inNewContext.lastIndexOf;
module.exports.mixin               = inNewContext.mixin;
module.exports.noConflict          = inNewContext.noConflict;
module.exports.noop                = inNewContext.noop;
module.exports.now                 = inNewContext.now;
module.exports.parseInt            = inNewContext.parseInt;
module.exports.random              = inNewContext.random;
module.exports.reduce              = inNewContext.reduce;
module.exports.reduceRight         = inNewContext.reduceRight;
module.exports.result              = inNewContext.result;
module.exports.runInContext        = inNewContext.runInContext;
module.exports.size                = inNewContext.size;
module.exports.some                = inNewContext.some;
module.exports.sortedIndex         = inNewContext.sortedIndex;
module.exports.template            = inNewContext.template;
module.exports.unescape            = inNewContext.unescape;
module.exports.uniqueId            = inNewContext.uniqueId;
module.exports.all                 = inNewContext.all;
module.exports.any                 = inNewContext.any;
module.exports.detect              = inNewContext.detect;
module.exports.findWhere           = inNewContext.findWhere;
module.exports.foldl               = inNewContext.foldl;
module.exports.foldr               = inNewContext.foldr;
module.exports.include             = inNewContext.include;
module.exports.inject              = inNewContext.inject;
module.exports.first               = inNewContext.first;
module.exports.last                = inNewContext.last;
module.exports.sample              = inNewContext.sample;
module.exports.take                = inNewContext.take;
module.exports.head                = inNewContext.head;
module.exports.VERSION             = inNewContext.VERSION;
module.exports.walk                = inNewContext.walk;
module.exports.binary              = inNewContext.binary;
module.exports.curry2              = inNewContext.curry2;
module.exports.curry3              = inNewContext.curry3;
module.exports.enforce             = inNewContext.enforce;
module.exports.fix                 = inNewContext.fix;
module.exports.quaternary          = inNewContext.quaternary;
module.exports.rCurry              = inNewContext.rCurry;
module.exports.rcurry2             = inNewContext.rcurry2;
module.exports.rcurry3             = inNewContext.rcurry3;
module.exports.ternary             = inNewContext.ternary;
module.exports.unary               = inNewContext.unary;
module.exports.arity               = inNewContext.arity;
module.exports.always              = inNewContext.always;
module.exports.comparator          = inNewContext.comparator;
module.exports.complement          = inNewContext.complement;
module.exports.conjoin             = inNewContext.conjoin;
module.exports.disjoin             = inNewContext.disjoin;
module.exports.flip                = inNewContext.flip;
module.exports.flip2               = inNewContext.flip2;
module.exports.fnull               = inNewContext.fnull;
module.exports.functionalize       = inNewContext.functionalize;
module.exports.juxt                = inNewContext.juxt;
module.exports.mapArgs             = inNewContext.mapArgs;
module.exports.methodize           = inNewContext.methodize;
module.exports.pipeline            = inNewContext.pipeline;
module.exports.splat               = inNewContext.splat;
module.exports.unsplat             = inNewContext.unsplat;
module.exports.unsplatl            = inNewContext.unsplatl;
module.exports.unsplatr            = inNewContext.unsplatr;
module.exports.mapArgsWith         = inNewContext.mapArgsWith;
module.exports.bound               = inNewContext.bound;
module.exports.attempt             = inNewContext.attempt;
module.exports.iterators           = inNewContext.iterators;
module.exports.isAssociative       = inNewContext.isAssociative;
module.exports.isDecreasing        = inNewContext.isDecreasing;
module.exports.isEven              = inNewContext.isEven;
module.exports.isFloat             = inNewContext.isFloat;
module.exports.isIncreasing        = inNewContext.isIncreasing;
module.exports.isIndexed           = inNewContext.isIndexed;
module.exports.isInstanceOf        = inNewContext.isInstanceOf;
module.exports.isInteger           = inNewContext.isInteger;
module.exports.isJSON              = inNewContext.isJSON;
module.exports.isNegative          = inNewContext.isNegative;
module.exports.isNumeric           = inNewContext.isNumeric;
module.exports.isOdd               = inNewContext.isOdd;
module.exports.isPositive          = inNewContext.isPositive;
module.exports.isSequential        = inNewContext.isSequential;
module.exports.isValidDate         = inNewContext.isValidDate;
module.exports.isZero              = inNewContext.isZero;
module.exports.frequencies         = inNewContext.frequencies;
module.exports.renameKeys          = inNewContext.renameKeys;
module.exports.setPath             = inNewContext.setPath;
module.exports.snapshot            = inNewContext.snapshot;
module.exports.updatePath          = inNewContext.updatePath;
module.exports.accessor            = inNewContext.accessor;
module.exports.dictionary          = inNewContext.dictionary;
module.exports.getPath             = inNewContext.getPath;
module.exports.hasPath             = inNewContext.hasPath;
module.exports.kv                  = inNewContext.kv;
module.exports.omitWhen            = inNewContext.omitWhen;
module.exports.pickWhen            = inNewContext.pickWhen;
module.exports.selectKeys          = inNewContext.selectKeys;
module.exports.add                 = inNewContext.add;
module.exports.bitwiseAnd          = inNewContext.bitwiseAnd;
module.exports.bitwiseLeft         = inNewContext.bitwiseLeft;
module.exports.bitwiseNot          = inNewContext.bitwiseNot;
module.exports.bitwiseOr           = inNewContext.bitwiseOr;
module.exports.bitwiseRight        = inNewContext.bitwiseRight;
module.exports.bitwiseXor          = inNewContext.bitwiseXor;
module.exports.bitwiseZ            = inNewContext.bitwiseZ;
module.exports.dec                 = inNewContext.dec;
module.exports.div                 = inNewContext.div;
module.exports.eq                  = inNewContext.eq;
module.exports.gt                  = inNewContext.gt;
module.exports.gte                 = inNewContext.gte;
module.exports.inc                 = inNewContext.inc;
module.exports.lt                  = inNewContext.lt;
module.exports.lte                 = inNewContext.lte;
module.exports.mod                 = inNewContext.mod;
module.exports.mul                 = inNewContext.mul;
module.exports.neg                 = inNewContext.neg;
module.exports.neq                 = inNewContext.neq;
module.exports.not                 = inNewContext.not;
module.exports.seq                 = inNewContext.seq;
module.exports.sneq                = inNewContext.sneq;
module.exports.sub                 = inNewContext.sub;
module.exports.camelCase           = inNewContext.camelCase;
module.exports.capitalize          = inNewContext.capitalize;
module.exports.explode             = inNewContext.explode;
module.exports.fromQuery           = inNewContext.fromQuery;
module.exports.humanize            = inNewContext.humanize;
module.exports.implode             = inNewContext.implode;
module.exports.regexEscape         = inNewContext.regexEscape;
module.exports.slugify             = inNewContext.slugify;
module.exports.snakeCase           = inNewContext.snakeCase;
module.exports.strContains         = inNewContext.strContains;
module.exports.stripTags           = inNewContext.stripTags;
module.exports.titleCase           = inNewContext.titleCase;
module.exports.toDash              = inNewContext.toDash;
module.exports.toQuery             = inNewContext.toQuery;
module.exports.done                = inNewContext.done;
module.exports.trampoline          = inNewContext.trampoline;
module.exports.cat                 = inNewContext.cat;
module.exports.chunk               = inNewContext.chunk;
module.exports.chunkAll            = inNewContext.chunkAll;
module.exports.collate             = inNewContext.collate;
module.exports.cons                = inNewContext.cons;
module.exports.cycle               = inNewContext.cycle;
module.exports.interpose           = inNewContext.interpose;
module.exports.iterateUntil        = inNewContext.iterateUntil;
module.exports.keepIndexed         = inNewContext.keepIndexed;
module.exports.mapcat              = inNewContext.mapcat;
module.exports.reductions          = inNewContext.reductions;
module.exports.repeat              = inNewContext.repeat;
module.exports.reverseOrder        = inNewContext.reverseOrder;
module.exports.splitAt             = inNewContext.splitAt;
module.exports.takeSkipping        = inNewContext.takeSkipping;
module.exports.weave               = inNewContext.weave;
module.exports.best                = inNewContext.best;
module.exports.dropWhile           = inNewContext.dropWhile;
module.exports.keep                = inNewContext.keep;
module.exports.nth                 = inNewContext.nth;
module.exports.partitionBy         = inNewContext.partitionBy;
module.exports.second              = inNewContext.second;
module.exports.splitWith           = inNewContext.splitWith;
module.exports.takeWhile           = inNewContext.takeWhile;
module.exports.third               = inNewContext.third;
module.exports.exists              = inNewContext.exists;
module.exports.existsAll           = inNewContext.existsAll;
module.exports.falsey              = inNewContext.falsey;
module.exports.falseyAll           = inNewContext.falseyAll;
module.exports.firstExisting       = inNewContext.firstExisting;
module.exports.truthy              = inNewContext.truthy;
module.exports.truthyAll           = inNewContext.truthyAll;
